import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//eslint-disable-next-line
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { formatDateTime } from "../../../common/Validations";
import PQQuestionnaireTabs from "../../../Components/PQ/PQQuestionnaireTabs";
import {
  getPQVendorDetail,
  getPQSubmissionDetails,
  addPQSubmissionRef,
} from "../../../redux/feature/supplier_app/pqVendorSlice";
// eslint-disable-next-line
const sectionRow = (label, value) => (
  <tr>
    <td style={{ fontWeight: 600, width: "40%" }}>{label}</td>
    <td>{value || "--"}</td>
  </tr>
);

const showDate = (value) => {
  if (!value) return "";
  return formatDateTime(value) || value;
};

const PQVendorDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Vendor");
  localStorage.setItem("submenu", "PQ Vendor Details");

  const pqVendorId = useSelector(
    (state) => state?.pqVendor?.pqDetail?.pqVendorId
  );
  const pqDetail = useSelector((state) => state?.pqVendor?.pqDetail);
  const pqSubmission = useSelector((state) => state?.pqVendor?.pqSubmission);
  const userEmail = useSelector((state) => state?.user?.data?.email);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isQuestionnaireVisible, setQuestionnaireVisible] = useState(true);

  const detail = pqDetail?.data || {};
  const invitation = detail.invitation || pqSubmission?.data?.invitation || {};
  const submission =
    detail.submission || pqSubmission?.data?.submission || {};
  const companyInfo =
    submission.companyInformation ||
    detail.submission?.companyInformation ||
    {};
  const hasSubmission = Boolean(
    detail.hasSubmission ||
      submission.referenceNumber ||
      submission.status === "Submitted"
  );

  useEffect(() => {
    if (pqVendorId) {
      dispatch(getPQVendorDetail({ pqVendorId }));
      dispatch(getPQSubmissionDetails({ pqVendorId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pqVendorId]);

  useEffect(() => {
    if (!pqVendorId && !userEmail) {
      navigate(Constants.PQ_VENDOR_LIST);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleCardVisibility1 = () => setCardVisible1(!isCardVisible1);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);

  const openSubmissionDetails = () => {
    dispatch(
      addPQSubmissionRef({
        referenceNumber:
          detail.referenceNumber || submission.referenceNumber || "",
        email: detail.email !== "--" ? detail.email || "" : "",
      })
    );
    navigate(Constants.PQ_SUBMISSION_DETAILS);
  };

  const statusValue =
    detail.status || invitation.status || submission.status || "Invited";

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <h2 className="mainTitle">
                  PQ Vendor Details{" "}
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {detail.pqVendorId || pqVendorId || "--"}
                  </span>
                </h2>
                <p className="subText">Pre-Qualification Vendor Information</p>
              </Col>
              <hr />
            </Row>

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigate(Constants.PQ_VENDOR_LIST)}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={8} lg={8} className="text-end">
                <button className="btnBack" onClick={openSubmissionDetails}>
                  <i className="bi bi-file-earmark-text"></i> Submission Details
                </button>
              </Col>
            </Row>

            <div className="mt-2 mb-3">
              <TableStatusField status={statusValue} />
            </div>

            <div className="accordion mb-4" id="pqVendorDetailsAccordion">
              {/* 01 Vendor / Invitation Header */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">VD</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Vendor Header Details</span>
                      <span className="subHeaderTitle">
                        Pre-qualification invitation summary
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="text-end pe-3">
                      <span className="headerStatusDetailedPage">
                        {detail.sourceType || "Invitation"}
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PQ Vendor ID"
                          name="pqVendorId"
                          id="pqVendorId"
                          placeholder=""
                          value={detail.pqVendorId || pqVendorId || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Supplier ID"
                          name="supplierId"
                          id="supplierId"
                          placeholder=""
                          value={detail.supplierId || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status"
                          name="status"
                          id="status"
                          placeholder=""
                          value={statusValue}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyName"
                          id="companyName"
                          placeholder=""
                          value={
                            detail.companyName ||
                            detail.organisationName ||
                            invitation.companyName ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          id="email"
                          placeholder=""
                          value={detail.email || invitation.email || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Category"
                          name="category"
                          id="category"
                          placeholder=""
                          value={detail.category || invitation.category || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sub Category"
                          name="subCategory"
                          id="subCategory"
                          placeholder=""
                          value={
                            detail.subCategory || invitation.subCategory || ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Template"
                          name="template"
                          id="template"
                          placeholder=""
                          value={detail.template || invitation.template || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Reference Number"
                          name="referenceNumber"
                          id="referenceNumber"
                          placeholder=""
                          value={
                            detail.referenceNumber ||
                            submission.referenceNumber ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Submission Deadline"
                          name="submissionDeadline"
                          id="submissionDeadline"
                          placeholder=""
                          value={
                            showDate(
                              detail.submissionDeadline ||
                                invitation.submissionDeadline
                            ) || ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invited By"
                          name="invitedBy"
                          id="invitedBy"
                          placeholder=""
                          value={
                            detail.invitedByName ||
                            detail.invitedBy ||
                            invitation.invitedByName ||
                            invitation.invitedBy ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Source"
                          name="sourceType"
                          id="sourceType"
                          placeholder=""
                          value={detail.sourceType || "Invitation"}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created Date"
                          name="createdAt"
                          id="createdAt"
                          placeholder=""
                          value={showDate(detail.createdAt) || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Updated Date"
                          name="updatedAt"
                          id="updatedAt"
                          placeholder=""
                          value={showDate(detail.updatedAt) || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Invitation Message"
                          name="message"
                          id="message"
                          value={detail.message || invitation.message || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              {/* 02 Assessment Snapshot */}
              <div className="accordion-item mt-3">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AS</span>
                    </Col>
                    <Col xs={10} md={10} lg={10}>
                      <span className="headerTitle">Assessment Snapshot</span>
                      <span className="subHeaderTitle">
                        Submitted questionnaire summary
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {!hasSubmission ? (
                      <p className="subText mb-0">
                        Assessment has not been submitted yet. Only invitation
                        details are available.
                      </p>
                    ) : (
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Assessment Status"
                            name="assessmentStatus"
                            id="assessmentStatus"
                            value={submission.status || statusValue}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Submitted By"
                            name="submittedBy"
                            id="submittedBy"
                            value={
                              detail.submittedBy || submission.submittedBy || ""
                            }
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Submitted At"
                            name="submittedAt"
                            id="submittedAt"
                            value={
                              showDate(
                                detail.submittedAt || submission.createdAt
                              ) || ""
                            }
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Name (Submitted)"
                            name="submittedCompanyName"
                            id="submittedCompanyName"
                            value={companyInfo.companyName || ""}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="GST Number"
                            name="gstNumber"
                            id="gstNumber"
                            value={companyInfo.gstNumber || ""}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="PAN Number"
                            name="panNumber"
                            id="panNumber"
                            value={companyInfo.panNumber || ""}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>

              {/* 03 Questionnaire */}
              <div className="accordion-item mt-3">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isQuestionnaireVisible
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={() =>
                          setQuestionnaireVisible(!isQuestionnaireVisible)
                        }
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QN</span>
                    </Col>
                    <Col xs={10} md={10} lg={10}>
                      <span className="headerTitle">Questionnaire</span>
                      <span className="subHeaderTitle">
                        {hasSubmission
                          ? "Submitted questionnaire response"
                          : "Questionnaire not submitted yet"}
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isQuestionnaireVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <PQQuestionnaireTabs
                      detail={detail}
                      submission={submission}
                      invitation={invitation}
                    />
                  </div>
                </div>
              </div>

              {/* 04 Quick Links */}
              <div className="accordion-item mt-3">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QL</span>
                    </Col>
                    <Col xs={10} md={10} lg={10}>
                      <span className="headerTitle">Quick Actions</span>
                      <span className="subHeaderTitle">
                        Navigate related PQ screens
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-2">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <button
                          className="btnTable"
                          onClick={openSubmissionDetails}
                        >
                          <i className="bi bi-file-earmark-text"></i> Open
                          Submission Details
                        </button>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <button
                          className="btnTable"
                          onClick={() => navigate(Constants.PQ_VENDOR_LIST)}
                        >
                          <i className="bi bi-arrow-left"></i> Back to PQ Vendor
                          List
                        </button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {pqDetail?.status && (
              <p className="subText mt-2">Loading PQ vendor details...</p>
            )}
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default PQVendorDetails;
